<div class="pagination" *ngIf="total > 10">
  <button
    class="pagination__navigation"
    [disabled]="value.page === 1"
    (click)="selectPage(value.page - 1)"
  >
    << Previous
  </button>
  <button
    class="pagination__page"
    *ngIf="value.page > 2 && totalPages > 3"
    (click)="selectPage(1)"
  >
    1
  </button>
  <div *ngIf="value.page > 3 && totalPages > 4" class="pagination__dots">
    <span>...</span>
  </div>
  <button
    class="pagination__page"
    *ngFor="let page of visiblePages"
    [class.selected]="value.page === page"
    (click)="selectPage(page)"
  >
    {{ page }}
  </button>
  <div
    *ngIf="
      totalPages > visibleRangeLength &&
      value.page < totalPages - 2 &&
      totalPages > 4
    "
    class="pagination__dots"
  >
    <span>...</span>
  </div>
  <button
    class="pagination__page"
    *ngIf="totalPages > visibleRangeLength && value.page < totalPages - 1"
    (click)="selectPage(totalPages)"
  >
    {{ totalPages }}
  </button>
  <button
    class="pagination__navigation"
    [disabled]="value.page === totalPages"
    (click)="selectPage(value.page + 1)"
  >
    Next >>
  </button>
</div>
